import React from 'react';
require('style/AlgorithmSettings');

const minAxiomaVersion = "1.2.2";
const minFlashingVersion = "1.2.5";
const minHwSettingsVersion = "1.2.7";
const minCombineDecimalsVersion = "1.2.14";
const disableDynamicMaxIncrementVersion = "1.2.16"

class AlgorithmSettings extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            developerMode: false,
            param1name: "",
            param1value: ""
        }
    }
    enableDevMode() {
        if (confirm("HERE BE DRAGONS! Are you sure you want to continue?")) {
            this.setState({ developerMode: true });
        }
    }

    valueToUseChanged(e) {
        console.log("valueToUseChanged:", e.target.value);
        if (e.target.value == 2) {
            this.props.setSetting('alarms.noDataTimeout', 86400);
        } else {
            this.props.deleteSetting('alarms.noDataTimeout');
        }
        this.props.setSetting('data.valueToUse', parseInt(e.target.value))

    }
    specialModeChanged(e) {
        let mode = e.target.value;
        if (mode == "axioma") {
            this.props.setSetting('device.debug', 0);
            this.props.setSetting('device.minAxiomaAccuracy', 0.9);
            this.props.setSetting('device.offsetY', 0);

        }
        else if (mode == 'flashing') {
            this.props.setSetting('digits.maxIncrease', 1.0);
            this.props.setSetting('device.restartAnalyzeImmediately', 0);
            this.props.setSetting('device.debug', 0);
        }
        this.props.setSetting('device.model', mode);
    }
    checkMinVersion(version, minVersion) {
        try {
            let cversion = parseInt(version.split(".").join(''));
            let mversion = parseInt(minVersion.split(".").join(''));
            if (cversion >= mversion) return true
            return false;
        } catch (err) {
            console.log("ERROR checking min version.", err);
            return false
        }

        //console.log("Major:",vMajor,"Minor:",vMinor,"Patch:",vPatch);
    }
    handleCustomMsgSend() {
        console.log("handleCustomMsgSend", this);
        let params = {}
        if (this.state.param1name !== "") {
            if (isNaN(parseInt(this.state.param1value))) {
                params[this.state.param1name] = this.state.param1value;
            } else {
                params[this.state.param1name] = parseInt(this.state.param1value);
            }
        }
        console.log("sending custom message:", this.state.customMsg, "params:", params);
        this.props.runCustomCmd(this.state.customMsg, params).then((result) => {
            console.log("custom message response:", result);
        }).catch((err) => {
            console.log("Command failed with error:", err);
        });
    }
    render() {
        /*console.log("AlgorithmVersion:", this.props.settings);
        console.log("Debug:",this.state.developerMode);*/
        //console.log("Props:",this.props);
        //console.log("Device sw:", this.props.deviceSwVersion);

        //console.log("camVer:", this.props.camVer);
        let valueToUse = this.props.settings.data.valueToUse;
        if (!valueToUse) valueToUse = 0;
        const mlDevice = this.props.deviceSwName.indexOf("-ml") !== -1;
        const allowUnreliableValues = this.props.settings.data.allowUnreliableValues;
        let deviceModel = "";
        if (this.props.settings.device && this.props.settings.device.model) {
            deviceModel = this.props.settings.device.model;
        }
        let minAxiomaAccuracy = 0.9;
        if (this.props.settings.device && this.props.settings.device.minAxiomaAccuracy) {
            minAxiomaAccuracy = this.props.settings.device.minAxiomaAccuracy;
        }
        let maximumIntegerIncrement = 1;
        if (this.props.settings.digits && this.props.settings.digits.maximumIntegerIncrement) {
            maximumIntegerIncrement = this.props.settings.digits.maximumIntegerIncrement;
        }

        let offsetY = 0;
        if (this.props.settings.device && this.props.settings.device.offsetY) {
            offsetY = this.props.settings.device.offsetY;
        }
        let specialDeviceDebug = 0;
        if (this.props.settings.device && this.props.settings.device.debug) {
            specialDeviceDebug = this.props.settings.device.debug;
        }
        let maxIncrease = 1.0;
        if (this.props.settings.digits && this.props.settings.digits.maxIncrease) {
            maxIncrease = this.props.settings.digits.maxIncrease;
        }
        let restartAnalyzeImmediately = 0;
        if (this.props.settings.device && this.props.settings.device.restartAnalyzeImmediately) {
            restartAnalyzeImmediately = this.props.settings.device.restartAnalyzeImmediately;
        }
        let allowLeadingNulls = 0;
        if (this.props.settings.device && this.props.settings.device.allowLeadingNulls) {
            allowLeadingNulls = this.props.settings.device.allowLeadingNulls;
        }
        let leaddigitcompensation = 0;
        if (this.props.settings.device && this.props.settings.device.leaddigitcompensation) {
            leaddigitcompensation = this.props.settings.device.leaddigitcompensation;
        }
        let threshold = 7;
        if (this.props.settings.device && this.props.settings.device.leaddigitcompensationthreshold) {
            threshold = this.props.settings.device.leaddigitcompensationthreshold;
        }
        let terminalState = 0;
        if (this.props.settings.device && this.props.settings.device.terminalOn) {
            terminalState = this.props.settings.device.terminalOn;
        }
        //const showDeviceTypeSelect = mlDevice && 
        //console.log("Device sw:", this.props.swVersion);
        var values = [];
        if (this.state.developerMode) {
            values.push(<option key="ml" value="mlreaderjs">ML</option>);
            values.push(<option key="kam" value="kamstrup_v1">Kamstrup v1</option>);
        } else if (mlDevice) {
            values.push(<option key="ml" value="mlreaderjs">ML</option>);
        } else {
            values.push(<option key="kam" value="kamstrup_v1">Kamstrup v1</option>);
        }

        const algo = this.props.settings.digits.algoVersion ? this.props.settings.digits.algoVersion : "";
        //console.log("DEBUG:", algo);
        let host = location.hostname;
        let disableAutoConfig = 0;
        if (this.props.settings && this.props.settings.device && this.props.settings.device.disableAutoConfig) {
            disableAutoConfig = this.props.settings.device.disableAutoConfig;
        }
        let disableDynamicMaxIncrement = 0;
        if (this.props.settings && this.props.settings.digits && this.props.settings.digits.disableDynamicMaxIncrement) {
            disableDynamicMaxIncrement = this.props.settings.digits.disableDynamicMaxIncrement;
        }
        //console.log("DEBBUG: ",host);
        return <div className="AlgorithmSettings">
            {(host === 'localhost' || host === "config.smartvatten.io" || host === "config.testflowone.io") && <div className="devOps">
                <button type="button" onClick={this.enableDevMode.bind(this)}>*</button>
            </div>}
            <div className='mainContainer'>
                <div className='leftContainer'>
                    {(this.checkMinVersion(this.props.deviceSwVersion, minHwSettingsVersion) || this.props.deviceSwName === "flowone-mlt3" || this.props.deviceSwName === "flowone-mlt4") && <fieldset className='fieldset'>
                        <legend>Hardware settings</legend>
                        <div className='settingsDiv'>
                            Max camera resolution:
                            <select value={this.props.settings.camera.resolution} onChange={(e) => this.props.setSetting('camera.resolution', e.target.value)}>
                                <option value="640x480">Vga</option>
                                {(this.props.camVer === "G" || this.props.camVer === "H" ) && <option value="1920x1080">1080p</option>}
                            </select>
                        </div>
                    </fieldset>}
                    <fieldset className='fieldset'>
                        <legend>Algorithm settings</legend>
                        <div className='settingsDiv'>
                            Algorithm to use:
                            <select value={algo} onChange={(e) => this.props.setSetting('digits.algoVersion', e.target.value)}>
                                <option value="">Default</option>
                                {values}
                            </select>
                        </div>
                    </fieldset>
                    <fieldset className='fieldset'>
                        <legend>Data settings</legend>

                        <div className='settingsDiv'>
                            Value to use:
                            <select value={valueToUse} onChange={(e) => this.valueToUseChanged(e)}>
                                <option value="0">0 (pointers)</option>
                                <option value="2">2 (no decimals)</option>
                                <option value="3">3 (digit decimals)</option>
                            </select>
                        </div>
                        <div className='settingsDiv'>Allow unreliable values:
                            <select value={allowUnreliableValues}
                                onChange={(e) => this.props.setSetting('data.allowUnreliableValues', parseInt(e.target.value))}>
                                <option value="0">No</option>
                                <option value="1">Yes</option>
                            </select></div>
                        <div className='settingsDiv'>diffNoFlowCalculation:
                            <select value={this.props.settings.data.diffNoFlowCalculation}
                                onChange={(e) => this.props.setSetting('data.diffNoFlowCalculation', parseInt(e.target.value))}>
                                <option value="0">No</option>
                                <option value="1">Yes</option>
                            </select></div>

                    </fieldset>
                    {valueToUse == 0 && <fieldset className='fieldset'>
                        <legend>Decimal settings</legend>
                        <div className='settingsDiv'>
                            <label>minimumPotentiometerSize:</label>
                            <input value={this.props.settings.decimals.minimumPotentiometerSize} type='text' onChange={(e) => this.props.setSetting('decimals.minimumPotentiometerSize', parseInt(e.target.value))} />
                        </div>
                    </fieldset>}
                    <fieldset className='fieldset'>
                        <legend>Special device settings</legend>

                        <div className='settingsDiv'>Disable auto config:
                            <select value={disableAutoConfig}
                                onChange={(e) => this.props.setSetting('device.disableAutoConfig', parseInt(e.target.value))}>
                                <option value="0">No</option>
                                <option value="1">Yes</option>
                            </select></div>
                        {(this.checkMinVersion(this.props.deviceSwVersion, disableDynamicMaxIncrementVersion) || this.props.deviceSwName === "flowone-mlt3") && <div className='settingsDiv'>Disable DynamicMaxIncrement:
                            <select value={disableDynamicMaxIncrement}
                                onChange={(e) => this.props.setSetting('digits.disableDynamicMaxIncrement', parseInt(e.target.value))}>
                                <option value="0">No</option>
                                <option value="1">Yes</option>
                            </select>
                        </div>}
                        {((this.checkMinVersion(this.props.deviceSwVersion, disableDynamicMaxIncrementVersion) || this.props.deviceSwName === "flowone-mlt3") && disableDynamicMaxIncrement !== 0) && <div className="settingsDiv extraSettingDiv">
                            <label>maximumIntegerIncrement:</label>
                            <input value={maximumIntegerIncrement} type='text' onChange={(e) => this.props.setSetting('digits.maximumIntegerIncrement', parseFloat(e.target.value))} />
                        </div>}

                        <div className='settingsDiv'>
                            Device mode:
                            <select value={deviceModel} onChange={(e) => this.specialModeChanged(e)}>
                                <option value="">Normal</option>
                                {(this.checkMinVersion(this.props.deviceSwVersion, minAxiomaVersion) || this.props.deviceSwName === "flowone-mlt3") && <option value="axioma">Axioma flashing</option>}
                                {(this.checkMinVersion(this.props.deviceSwVersion, minFlashingVersion) || this.props.deviceSwName === "flowone-mlt3") && <option value="flashing">Generic Flashing</option>}
                                {(this.checkMinVersion(this.props.deviceSwVersion, minCombineDecimalsVersion) || this.props.deviceSwName === "flowone-mlt3") && <option value="combinedecimals">Combine decimals</option>}
                            </select>
                        </div>
                        {deviceModel == "axioma" && <div>
                            <div className='settingsDiv extraSettingDiv'>
                                <label>minAxiomaAccuracy:</label>
                                <input value={minAxiomaAccuracy} type='text' onChange={(e) => this.props.setSetting('device.minAxiomaAccuracy', parseFloat(e.target.value))} />
                            </div>
                            <div className='settingsDiv extraSettingDiv'>
                                <label>offsetY:</label>
                                <input value={offsetY} type='text' onChange={(e) => this.props.setSetting('device.offsetY', parseInt(e.target.value))} />
                            </div>
                        </div>}
                        {deviceModel == 'flashing' && <div>
                            <div className='settingsDiv extraSettingDiv'>
                                <label>maxIncrease</label>
                                <input value={maxIncrease} type='text' onChange={(e) => this.props.setSetting('digits.maxIncrease', parseFloat(e.target.value))} />
                            </div>
                            <div className='settingsDiv extraSettingDiv'>
                                <label>Restart cycle immediately:</label>
                                <select value={restartAnalyzeImmediately}
                                    onChange={(e) => this.props.setSetting('device.restartAnalyzeImmediately', parseInt(e.target.value))}>
                                    <option value="1">Yes</option>
                                    <option value="0">No</option>
                                </select>
                            </div>
                            <div className='settingsDiv extraSettingDiv'>
                                <label>Allow leading nulls:</label>
                                <select value={allowLeadingNulls}
                                    onChange={(e) => this.props.setSetting('device.allowLeadingNulls', parseInt(e.target.value))}>
                                    <option value="1">Yes</option>
                                    <option value="0">No</option>
                                </select>
                            </div>
                        </div>}
                        {deviceModel === 'combinedecimals' && valueToUse == "3" && <div>
                            <div className='settingsDiv extraSettingDiv'>
                                <label>Leading digit compensation:</label>
                                <select value={leaddigitcompensation}
                                    onChange={(e) => this.props.setSetting('device.leaddigitcompensation', parseInt(e.target.value))}>
                                    <option value="1">Yes</option>
                                    <option value="0">No</option>
                                </select>
                            </div>
                            {leaddigitcompensation == 1 && <div>
                                <div className='settingsDiv extraSettingDiv'>
                                    <label>Threshold</label>
                                    <input defaultValue={threshold} type='text' onChange={(e) => this.props.setSetting('device.leaddigitcompensationthreshold', parseFloat(e.target.value))} />
                                </div>
                            </div>}
                        </div>}
                        <br />
                        <div className='settingsDiv'>
                            <label>Debug:</label>
                            <select value={specialDeviceDebug}
                                onChange={(e) => this.props.setSetting('device.debug', parseInt(e.target.value))}>
                                <option value="0">No</option>
                                <option value="1">Yes</option>
                            </select>
                        </div>

                    </fieldset>
                </div>
                <div className='rightContainer'>
                    <div>
                        <fieldset className='fieldset'>
                            <legend>Alarms settings</legend>
                            <div className='settingsDiv'>
                                <label>minRunNightLimit:</label>
                                <input value={this.props.settings.alarms.minRunNightLimit} type='text' onChange={(e) => this.props.setSetting('alarms.minRunNightLimit', parseInt(e.target.value))} />
                            </div>
                            <div className='settingsDiv'>
                                <label>hourAlarmLimit:</label>
                                <input value={this.props.settings.alarms.hourAlarmLimit} type='text' onChange={(e) => this.props.setSetting('alarms.hourAlarmLimit', parseInt(e.target.value))} />
                            </div>
                            <div className='settingsDiv'>
                                <label>pointersFailRateLimit:</label>
                                <input value={this.props.settings.alarms.pointersFailRateLimit} type='text' onChange={(e) => this.props.setSetting('alarms.pointersFailRateLimit', parseInt(e.target.value))} />
                            </div>
                            <div className='settingsDiv'>
                                <label>noDataTimeout:</label>
                                <input value={this.props.settings.alarms.noDataTimeout} type='text' onChange={(e) => this.props.setSetting('alarms.noDataTimeout', parseInt(e.target.value))} />
                            </div>
                        </fieldset>
                    </div>
                    <div>
                        <fieldset className='fieldset'>
                            <legend>Intervals settings</legend>
                            <div className='settingsDiv'>
                                <label>dataStorageInterval:</label>
                                <input value={this.props.settings.intervals.dataStorageInterval} type='text' onChange={(e) => this.props.setSetting('intervals.dataStorageInterval', parseInt(e.target.value))} />
                            </div>
                            <div className='settingsDiv'>
                                <label>dataUploadInterval:</label>
                                <input value={this.props.settings.intervals.dataUploadInterval} type='text' onChange={(e) => this.props.setSetting('intervals.dataUploadInterval', parseInt(e.target.value))} />
                            </div>
                            <div className='settingsDiv'>
                                <label>sendPictureInterval:</label>
                                <input value={this.props.settings.intervals.sendPictureInterval} type='text' onChange={(e) => this.props.setSetting('intervals.sendPictureInterval', parseInt(e.target.value))} />
                            </div>
                            <div className='settingsDiv'>
                                <label>nightTimeImageCaptureInterval:</label>
                                <input value={this.props.settings.intervals.nightTimeImageCaptureInterval} type='text' onChange={(e) => this.props.setSetting('intervals.nightTimeImageCaptureInterval', parseInt(e.target.value))} />
                            </div>
                            <div className='settingsDiv'>
                                <label>imageCaptureInterval:</label>
                                <input value={this.props.settings.intervals.imageCaptureInterval} type='text' onChange={(e) => this.props.setSetting('intervals.imageCaptureInterval', parseInt(e.target.value))} />
                            </div>
                        </fieldset>
                        <fieldset className='fieldset'>
                            <legend>Special settings:</legend>
                            <div className='settingsDiv'>
                                <label>Terminal:</label>
                                <select value={terminalState}
                                    onChange={(e) => this.props.terminalStateChange(parseInt(e.target.value))}>
                                    <option value="0">Off</option>
                                    <option value="1">On</option>
                                </select>
                            </div>
                        </fieldset>
                    </div>
                    {this.state.developerMode && <div>
                        
                        <fieldset className='fieldset'>
                            <legend>Send custom message</legend>
                            <div className='settingsDiv'>
                                <label>MSG</label>
                                <input value={this.state.customMsg} type="text" onChange={(e) => { this.setState({ customMsg: e.target.value }) }} />
                            </div>
                            <div className='settingsDiv'>
                                <label>Param name</label>
                                <input value={this.state.param1name} type="text" onChange={(e) => { this.setState({ param1name: e.target.value }) }} />
                            </div>
                            <div className='settingsDiv'>
                                <label>Param value</label>
                                <input value={this.state.param1value} type="text" onChange={(e) => { this.setState({ param1value: e.target.value }) }} />
                            </div>
                            <div className='settingsDiv'>
                                <button type="button" onClick={this.handleCustomMsgSend.bind(this)}>Send</button>
                            </div>
                        </fieldset>
                    </div>

                    }
                </div>
            </div>
        </div>
    }
}

export default AlgorithmSettings;


// WEBPACK FOOTER //
// ./client/components/AlgorithmSettings.js